import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    // Если есть сохраненная позиция (например, при нажатии кнопки "назад")
    if (savedPosition) {
      return savedPosition
    }

    // Если есть hash в URL, пытаемся прокрутить к элементу
    if (to.hash) {
      // Ждем, пока DOM обновится
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.querySelector(to.hash)
          if (element) {
            return resolve({
              el: to.hash,
              behavior: 'smooth',
              top: 0
            })
          }
          // Если элемент не найден, просто прокручиваем вверх
          return resolve({ top: 0 })
        }, 100)
      })
    }

    // По умолчанию прокручиваем вверх
    return { top: 0 }
  }
}
